import * as React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

type Sizes = 'fa-sm' | 'fa-lg' | 'fa-2x' | 'fa-3x' | 'fa-4x' | 'fa-5x';
interface LoadingProps {
  size?: Sizes;
  noPadding?: boolean;
  className?: string;
}

const Loading: React.FC<LoadingProps> = ({
  size = 'fa-sm',
  className = '',
}) => (
    <div className={className}>
      <div>
        <i className={`fa fa-spinner fa-spin ${size}`}></i>
      </div>
    </div>
  );

Loading.propTypes = {
  size: PropTypes.oneOf(['fa-sm', 'fa-lg', 'fa-2x', 'fa-3x', 'fa-4x', 'fa-5x']),
  className: PropTypes.string,
};

const StyledLoading = styled(Loading)`
  display: flex;
  padding: ${({ noPadding }) => (noPadding ? '0' : '2em')};
  width: 100%;
  > div {
    margin: auto;
  }
`;

export default StyledLoading;
